import { motion } from "framer-motion";
import { GALLERY } from "../data";

export const Gallery = () => (
  <section id="gallery" data-testid="gallery-section" className="relative bg-forest py-28 md:py-40">
    <div className="max-w-[1600px] mx-auto px-6 md:px-12">
      <motion.div
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        className="mb-16 md:mb-24"
      >
        <p className="text-xs tracking-[0.3em] uppercase text-amber mb-6" data-testid="gallery-label">
          Field Notes
        </p>
        <h2 className="font-display text-4xl md:text-6xl tracking-tight text-cream leading-[1.05]">
          Moments from <span className="italic text-amber">the wild.</span>
        </h2>
      </motion.div>

      <div className="columns-1 sm:columns-2 lg:columns-3 gap-6 [column-fill:balance]">
        {GALLERY.map((g, i) => (
          <motion.figure
            key={g.src}
            data-testid={`gallery-item-${i}`}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: (i % 3) * 0.12, ease: [0.16, 1, 0.3, 1] }}
            className="group relative overflow-hidden clip-frame border border-cream/10 mb-6 break-inside-avoid"
          >
            <img
              src={g.src}
              alt={g.caption}
              className={`w-full object-cover image-zoom ${g.tall ? "h-[480px]" : "h-[340px]"}`}
            />
            <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-night/95 via-night/40 to-transparent p-5 translate-y-2 opacity-0 group-hover:opacity-100 group-hover:translate-y-0 transition-[opacity,transform] duration-500">
              <p className="text-xs tracking-[0.15em] uppercase text-amber">{g.caption}</p>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);
